import { action } from 'typesafe-actions';
import { Coverage, COVERAGE_TYPES } from './types';

export const getCoverageList = () =>
  action(COVERAGE_TYPES.GET_COVERAGELIST_REQUEST);

export const setCoverageList = (data: Coverage[]) =>
  action(COVERAGE_TYPES.SET_DATA_COVERAGELIST, data);

export const getCoverageListByTypePDV = (typePDV: string) =>
  action(COVERAGE_TYPES.GET_COVERAGELIST_BY_TYPE_PDV_REQUEST, typePDV);

export const setCoverageListByTypePDV = (data: Coverage[]) =>
  action(COVERAGE_TYPES.SET_DATA_COVERAGELIST, data);
